import { useContext, useState } from 'react'

import { MaskedInput } from '~/components/TextInput'
import { CooperProtocol } from '~/modules/aerobicCapabilities/schema'
import { studentEvaluationDemoContext } from '~/pages/authenticated/personalTrainer/studentEvaluationDemo'

export const Cooper: React.FC = () => {
  const { data } = useContext(studentEvaluationDemoContext)

  const [value] = useState<CooperProtocol>({
    distance: data?.cooper?.distance ?? 0,
  })

  return (
    <div>
      <MaskedInput
        mask='integer'
        inputMode='numeric'
        value={value?.distance}
        label='Distância (m)'
        placeholder='0'
        onChange={() => undefined}
      />
    </div>
  )
}
